import InstantMessagePayload from 'owa-service/lib/contract/InstantMessagePayload';
import getChatBySessionId from '../selectors/getChatBySessionId';
import { addOrUpdatePresence } from '../../actions/presenceActions';
import { addPresenceSubscription } from '../presenceManager/presenceSubscription';
import {
    addParticipant as addParticipantAction,
    addChatMessage,
    updateParticipantDisplayName,
} from '../actions/ucmaActions';
import { ChatMessageType } from '../store/schema/ChatMessageViewState';

export default function addParticipant(notification: InstantMessagePayload) {
    if (notification.NewUserPresence) {
        addOrUpdatePresence(notification.SipUri, notification.NewUserPresence);
    }

    const { SipUri, DisplayName, ChatSessionId } = notification;
    const chat = getChatBySessionId(ChatSessionId);

    if (chat && SipUri) {
        const participant = chat.participants.filter(
            participant => participant.toLowerCase() == SipUri.toLowerCase()
        )[0];

        if (!participant) {
            addPresenceSubscription([SipUri]);
            addParticipantAction(chat, SipUri);
            updateParticipantDisplayName(SipUri, DisplayName);
            addChatMessage(chat, ChatMessageType.ParticipantJoin, SipUri);
        }
    }
}
